<template>
  <el-dialog :id="$options.name" :before-close="noDialog" :fullscreen="dialogFullscreen"
             :visible.sync="dialog"
             title="新增计费模板"
             width="60%"
  >
    <el-form ref="params" :label-position="labelPosition" :model="params" :rules="rules" label-width="auto">
      <el-form-item label="模板名称" prop="name">
        <el-input v-model="params.name" placeholder="请输入模板名称"/>
      </el-form-item>
      <el-form-item label="计费方式">
        <el-radio-group v-model="params.chargeType" @change="changeChargeType">
          <el-radio-button label="2">按度数</el-radio-button>
          <el-radio-button label="1">按时间</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <div v-if="params.chargeType === '2'">
        <el-form-item label="计费价格" prop="powerFare">
          <el-input v-model="params.powerFare" maxlength="4" placeholder="请输入计费价格">
            <template slot="append">元/度</template>
          </el-input>
        </el-form-item>
        <el-form-item label="起步价格">
          <el-row :gutter="5">
            <el-col :span="6" :xs="12">
              <el-checkbox v-model="checked">启用起步价</el-checkbox>
            </el-col>
            <el-col :span="9" :xs="24">
              <el-form-item prop="startingFare">
                <el-input v-model="params.startingFare"
                          :disabled="!checked"
                          maxlength="4" placeholder="请输入起步价格">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
      </div>
      <div v-else-if="params.chargeType==='1'">
        <el-form-item label="是否返费" prop="returnTheBalance">
          <el-checkbox v-model="params.returnTheBalance"
                       :false-label="'0'"
                       :true-label="'1'"
          >打勾退费
          </el-checkbox>
        </el-form-item>
        <el-form-item label="起步价格">
          <el-row :gutter="5">
            <el-col :span="6" :xs="12">
              <el-checkbox v-model="checked">启用起步价</el-checkbox>
            </el-col>
            <el-col :span="9" :xs="24">
              <el-form-item prop="startingFare">
                <el-input v-model="params.startingFare" :disabled="!checked" maxlength="4"
                          placeholder="请输入起步价格">
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form-item>
        <div v-for="(item,index) in params.chargeTemplateInfoList" :key="index">
          <el-form-item label="价格详细">
            <el-row>
              <el-col :span="4" :xs="11">
                <el-form-item :prop="'chargeTemplateInfoList.'+index+'.money'" :rules="rules.money">
                  <el-input v-model="item.money" maxlength="4">
                    <template slot="append">元</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="1" class="t-c hidden-sm-and-up">
                -
              </el-col>
              <el-col :span="5" :xs="12">
                <el-form-item :prop="'chargeTemplateInfoList.'+index+'.interval'"
                              :rules="rules.interval">
                  <el-input v-model.number="item.interval">
                    <template slot="append">分钟</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4" :xs="11" class="xs-m-p">
                <el-form-item :prop="'chargeTemplateInfoList.'+index+'.startPower'"
                              :rules="rules.startPower">
                  <el-input v-model.number="item.startPower" disabled>
                    <template slot="append">瓦</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="1" class="t-c xs-m-p">
                -
              </el-col>
              <el-col :span="4" :xs="12" class="xs-m-p">
                <el-form-item :prop="'chargeTemplateInfoList.'+index+'.endPower'"
                              :rules="rules.endPower">
                  <el-input v-model.number="item.endPower">
                    <template slot="append">瓦</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="3" :xs="6" class="xs-m-p">
                <el-button v-if="listStart(index)" type="primary" @click="addItem(item)">
                  新增
                </el-button>
              </el-col>
              <el-col :span="3" :xs="6" class="xs-m-p">
                <el-button v-if="listEnd(index)" type="danger"
                           @click="removeItem(item,params.chargeTemplateInfoList)">
                  删除
                </el-button>
              </el-col>
            </el-row>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div slot="footer">
      <el-button @click="noDialog">取消</el-button>
      <el-button type="primary" @click="addTemplate">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>

import addChargeTemplate from "@/api/device/charge-template-manage/addChargeTemplate";
import templateMixin from "@/mixin/templateMixin/templateMixin";

export default {
  name: "addTemplateDialog",
  mixins: [templateMixin],
  watch: {
    dialog(newValue) {
      if (newValue === true) {
        this.params = {
          chargeTemplateInfoList: [
            {
              interval: undefined,
              money: undefined,
              startPower: 0,
              endPower: undefined,
            }
          ],
          chargeType: "2",
          returnTheBalance: '0',
          name: undefined,
          powerFare: undefined,
          startingFare: undefined
        }
        this.$nextTick(() => {
          this.$refs['params'].clearValidate();
        })
      }
    }
  },
  data() {
    return {
      params: {},
      checked: false,
    }
  },
  methods: {
    addTemplate() {
      this.$refs['params'].validate((valid) => {
        if (valid) {
          let Dto = {...this.params}
          if (this.checked === false) {
            Dto.startingFare = 0;
          }
          if (Dto.chargeType === "2") {
            Dto.returnTheBalance = '0';
            delete Dto.chargeTemplateInfoList;
          } else if (Dto.chargeType === "1") {
            Dto.powerFare = 0;
          }
          this.loadStart();
          addChargeTemplate(Dto).then(res => {
                this.resNoDialog({res})
                this.checked = false;
              }
          ).finally(() => {
            this.loadDialog.close();
          });
        }
      });
    },
  },
}
</script>
